import { render, staticRenderFns } from "./postStationList.vue?vue&type=template&id=1f2c3218&scoped=true"
import script from "./postStationList.vue?vue&type=script&lang=js"
export * from "./postStationList.vue?vue&type=script&lang=js"
import style0 from "./postStationList.vue?vue&type=style&index=0&id=1f2c3218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2c3218",
  null
  
)

export default component.exports